import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { toastError, toastSuccess } from "../../Components/ToastNotification";
import "./form.css";
import CardHeader from "../../Components/CardHeader";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCircleCheck,
  faTruckArrowRight,
  faTruckLoading,
  faUser,
  faStickyNote,
} from "@fortawesome/free-solid-svg-icons";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { getByIdLoads, updateLoads } from "../../services/loads";
import { getDriver, getDriverDetails } from "../../services/users";
import { UnpdateloadlocationsModal } from "../../Components/UnpdateloadlocationsModal";
import { UnpdateUnloadlocationsModal } from "../../Components/UnpdateUnloadlocationsModal";

const headerButtons = [
  { buttonTitle: "Back to loads", buttonUrl: -1, icon: faArrowLeft },
];

const LoadsValidator = (value) => {
  let errors = {};
  if (!value["loading_location"]) {
    errors.loading_location = "Loading Location is required";
  }
  if (!value["loading_country"]) {
    errors.loading_country = "Loading Country is required";
  }
  if (!value["loading_country_code"]) {
    errors.loading_country_code = "Loading Country  Code is required";
  }
  if (!value["loading_reference"]) {
    errors.loading_reference = "Loading Reference is required";
  }
  if (!value["unloading_location"]) {
    errors.unloading_location = "Unloading Location is required";
  }
  if (!value["unloading_country"]) {
    errors.unloading_country = "Unloading Country is required";
  }
  if (!value["unloading_reference"]) {
    errors.unloading_reference = "Unloading Reference is required";
  }
  if (!value["driver"]) {
    errors.driver = "Driver is required";
  }
  if (!value["delivery_notes"]) {
    errors.delivery_notes = "Delivery Notes is required";
  }
  if (!value["goods_type"]) {
    errors.goods_type = "Goods Type is required";
  }
  if (!value["identification_position"]) {
    errors.identification_position = "Identification Position is required";
  }
  if (!value["loading_status"]) {
    errors.loading_status = "Loading Status is required";
  }
  return errors;
};

function LoadUpdate() {
  const { id } = useParams();
  const navgate = useNavigate();
  const [data, setData] = useState([]);
  const [date1, setdate] = useState(data.loading_date);
  const [date2, setdate2] = useState(data.unloading_date);
  const [drivers, setDrivers] = useState([]);
  // const [singleDriver, setSingleDriver] = useState(data.driver && data.driver);
  const [driverDetials, setDriverDetials] = useState();
  const [secondloaddata, setSecLoadData] = useState();
  const [secondunloaddata, setSecUnLoadData] = useState();
  const [modalshow, setModalShow] = useState(false);
  const [modalshowtwo, setModalShowTwo] = useState(false);
  const [formErrors, setFormErrors] = useState([]);
  const singleDriver = data.driver && data.driver;
  console.log(singleDriver)

  const handleClose = (value) => {
    setModalShow(value);
  };

  const handleClosetwo = (value) => {
    setModalShowTwo(value);
  };

  const secLoadData = (data) => {
    setSecLoadData(data);
  };

  const secUnLoadData = (data) => {
    setSecUnLoadData(data);
  };

  useEffect(() => {
    getByIdLoads(id).then((res) => setData(res.data));
    getDriver().then((res) => {
      setDrivers(res.data);
    });
  }, [id]);

  const loadedLocData = {
    second_loading_country: data.second_loading_country,
    second_loading_location: data.second_loading_location,
    second_loading_country_code: data.second_loading_country_code,
    second_loading_reference: data.second_loading_reference,
    second_loading_date: data.second_loading_date,
  };
  const UnloadedLocData = {
    second_unloading_country: data.second_unloading_country,
    second_unloading_location: data.second_unloading_location,
    second_unloading_country_code: data.second_unloading_country_code,
    second_unloading_reference: data.second_unloading_reference,
    second_unloading_date: data.second_unloading_date,
  };

  const formatDate = (date) => {
    let d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    let year = "" + d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let inputs = {
      ...data,
      [name]: value,
    };
    setData({ ...data, [name]: value });
    setFormErrors(LoadsValidator(inputs));
    if (inputs.driver) {
      getDriverDetails(inputs.driver).then((res) => {
        setDriverDetials(res.data);
      });
    }
  };
  console.log(data);
  // data['driver'] = driverDetials

  if (secondloaddata) {
    data["second_loading_country"] = secondloaddata["second_loading_country"];
    data["second_loading_location"] = secondloaddata["second_loading_location"];
    data["second_loading_country_code"] =
      secondloaddata["second_loading_country_code"];
    data["second_loading_reference"] =
      secondloaddata["second_loading_reference"];
    data["second_loading_date"] = secondloaddata["second_loading_date"];
  }
  if (secondunloaddata) {
    data["second_unloading_country"] =
      secondunloaddata["second_unloading_country"];
    data["second_unloading_location"] =
      secondunloaddata["second_unloading_location"];
    data["second_unloading_country_code"] =
      secondunloaddata["second_unloading_country_code"];
    data["second_unloading_reference"] =
      secondunloaddata["second_unloading_reference"];
    data["second_unloading_date"] = secondunloaddata["second_unloading_date"];
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (date1 !== undefined) {
      const dateOne = formatDate(date1._d);
      data["loading_date"] = dateOne;
    }
    if (date2 !== undefined) {
      const datatwo = formatDate(date2._d);
      data["unloading_date"] = datatwo;
    }
    data["driver"] = data.driver.id || data.driver;
    if (
      data.loading_location !== "" &&
      data.loading_country !== "" &&
      data.loading_country_code !== "" &&
      data.loading_reference !== "" &&
      data.unloading_location !== "" &&
      data.unloading_country !== "" &&
      data.unloading_country_code !== "" &&
      data.unloading_reference !== "" &&
      data.loading_status !== "" &&
      data.identification_position !== "" &&
      data.goods_type !== "" &&
      data.driver !== "" &&
      data.delivery_notes !== ""
    ) {
      updateLoads(id, data)
        .then((res) => {
          toastSuccess("loads successfully updated");
          navgate("../loads");
        })
        .catch((err) => {
          let errObj = err.response.data;
          toastError(errObj.error);
        });
    } else {
      setFormErrors(LoadsValidator(data));
    }
  };

  return (
    <div className="container-fluid">
      <CardHeader headerItems={headerButtons} title="Update" />
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col lg={6} sm={6} xs={6} md={6}>
            <Card className="mb-3 border-0 shadow-sm rounded-2">
              <Card.Body>
                <div className="form-wrapper">
                  <Row className="mb-3">
                    <Form.Group>
                      <Form.Label>
                        {" "}
                        <p className="h6 fw-700 mb-3 text-danger">
                          {" "}
                          <FontAwesomeIcon icon={faTruckLoading} /> From
                        </p>
                      </Form.Label>

                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          Loading Location
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="loading_location"
                          onChange={handleChange}
                          value={data.loading_location}
                          className="border-2"
                          isInvalid={formErrors.loading_location}
                        />
                        {formErrors.loading_location && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.loading_location}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>

                      <Form.Group>
                        <Form.Label className="fw-600">Loading Date</Form.Label>
                        <Datetime
                          onChange={(date) => setdate(date)}
                          name="loading_date"
                          initialViewMode={("years", "months", "days")}
                          value={date1 || new Date(data.loading_date)}
                          timeFormat={false}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          Loading Country
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="loading_country"
                          onChange={handleChange}
                          value={data.loading_country}
                          className="border-2"
                          placeholder="Enter the Country"
                          isInvalid={formErrors.loading_country}
                        />
                        {formErrors.loading_country && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.loading_country}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>

                      <Form.Group>
                        <Form.Label className="fw-600">
                          Loading Country Code
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="loading_country_code"
                          onChange={handleChange}
                          value={data.loading_country_code}
                          className="border-2"
                          placeholder="Enter the Country Code"
                          isInvalid={formErrors.loading_country_code}
                        />
                        {formErrors.loading_country_code && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.loading_country_code}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          Loading Reference{" "}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="loading_reference"
                          onChange={handleChange}
                          value={data.loading_reference}
                          className="border-2"
                          placeholder="Enter the Reference"
                          isInvalid={formErrors.loading_location}
                        />
                        {formErrors.loading_reference && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.loading_reference}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Form.Group>
                    <Button onClick={() => setModalShow(true)}>
                      Add Second load Location
                    </Button>
                    {modalshow ? (
                      <UnpdateloadlocationsModal
                        title="loaded"
                        showMod={modalshow}
                        onClose={handleClose}
                        loaddata={loadedLocData}
                        onSubmit={secLoadData}
                      />
                    ) : (
                      <UnpdateloadlocationsModal showMod={false} />
                    )}
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6} sm={6} xs={6} md={6}>
            <Card className="mb-3 border-0 shadow-sm rounded-2">
              <Card.Body>
                <div className="form-wrapper">
                  <Row className="mb-3">
                    <Form.Group>
                      <Form.Label>
                        {" "}
                        <p className="h6 fw-700  mb-3 text-danger">
                          {" "}
                          <FontAwesomeIcon icon={faTruckArrowRight} /> To{" "}
                        </p>{" "}
                      </Form.Label>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          UnLoading Location
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="unloading_location"
                          onChange={handleChange}
                          value={data.unloading_location}
                          className="border-2"
                          isInvalid={formErrors.unloading_location}
                        />
                        {formErrors.unloading_location && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.unloading_location}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>

                      <Form.Group>
                        <Form.Label className="fw-600">
                          UnLoading Date
                        </Form.Label>
                        <Datetime
                          onChange={(date) => setdate2(date)}
                          name="unloading_date"
                          value={date2 || new Date(data.unloading_date)}
                          timeFormat={false}
                          input
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          UnLoading Country
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="unloading_country"
                          onChange={handleChange}
                          value={data.unloading_country}
                          className="border-2"
                          placeholder="Enter the Country"
                          isInvalid={formErrors.unloading_country}
                        />
                        {formErrors.unloading_country && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.unloading_country}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          UnLoading Country Code
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="unloading_country_code"
                          onChange={handleChange}
                          value={data.unloading_country_code}
                          className="border-2"
                          placeholder="Enter the Country Code"
                          isInvalid={formErrors.unloading_country_code}
                        />
                        {formErrors.unloading_country_code && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.unloading_country_code}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          UnLoading Reference
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="unloading_reference"
                          onChange={handleChange}
                          value={data.unloading_reference}
                          className="border-2"
                          placeholder="Enter the Reference"
                          isInvalid={formErrors.unloading_reference}
                        />
                        {formErrors.unloading_reference && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.unloading_reference}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Form.Group>
                    <Button onClick={() => setModalShowTwo(true)}>
                      Add Second UnLoad Location
                    </Button>
                    {modalshowtwo ? (
                      <UnpdateUnloadlocationsModal
                        title="Unloaded"
                        showMod={modalshowtwo}
                        onClose={handleClosetwo}
                        loaddata={UnloadedLocData}
                        onSubmit={secUnLoadData}
                      />
                    ) : (
                      <UnpdateUnloadlocationsModal showMod={false} />
                    )}
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6} sm={6} xs={6} md={6}>
            <Card className="mb-3 border-0 shadow-sm rounded-2">
              <Card.Body>
                <div className="form-wrapper">
                  <Row className="mb-3">
                    <Form.Group>
                      <Form.Label>
                        {" "}
                        <p className="h6 fw-700 mb-3 text-danger">
                          {" "}
                          <FontAwesomeIcon icon={faUser} /> Driver
                        </p>
                      </Form.Label>

                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">Driver</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="driver"
                          onChange={handleChange}
                          // value={data.driver && data.driver.id}
                          isInvalid={formErrors.driver}
                        >
                          {drivers.map((item, idx) => (
                            <option key={idx} value={item.id}>
                              {item.user.first_name + " " + item.user.last_name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>

                      <Row className="mb-3">
                        <Form.Group>
                        {data.driver && data.driver  ? (
                            <>
                            <h3>Previous Data</h3>
                             <p>Truck Name : {data.driver.truck && data.driver.truck.truck_name}</p>
                            <p>Plate Number : {data.driver.truck && data.driver.truck.plate_number}</p>
                             <p>Trailer Name : {data.driver.trailer && data.driver.trailer.trailer_name}</p>
                            <p>Plate Number : {data.driver.trailer && data.driver.trailer.plate_number}</p>
                            </>
                           
                          ):""}
                          {driverDetials ? (
                            <>
                              <Table striped bordered hover className="mt-4">
                                <tbody>
                                  <tr>
                                    <td className="fw-700">Truck</td>
                                    <td>
                                      {driverDetials &&
                                        driverDetials.truck.truck_name}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="fw-700">
                                      Truck Plate Number
                                    </td>
                                    <td>
                                      {driverDetials &&
                                        driverDetials.truck.plate_number}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>

                              <Table striped bordered hover className="mt-5">
                                <tbody>
                                  <tr>
                                    <td className="fw-700">Trailer</td>
                                    <td>
                                      {driverDetials &&
                                        driverDetials.trailer.trailer_name}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="fw-700">
                                      Trailer Plate Number
                                    </td>
                                    <td>
                                      {driverDetials &&
                                        driverDetials.trailer.plate_number}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </>
                          ) : (
                       ""
                          )}
                        </Form.Group>
                      </Row>
                    </Form.Group>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6} sm={6} xs={6} md={6}>
            <Card className="mb-3 border-0 shadow-sm rounded-2">
              <Card.Body>
                <div className="form-wrapper">
                  <Row className="mb-3">
                    <Form.Group>
                      <Form.Label>
                        {" "}
                        <p className="h6 fw-700 mb-3 text-danger">
                          {" "}
                          <FontAwesomeIcon icon={faStickyNote} /> Additional
                          information
                        </p>
                      </Form.Label>

                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          Delivery notes
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          name="delivery_notes"
                          onChange={handleChange}
                          value={data.delivery_notes}
                          style={{ height: "100px" }}
                          isInvalid={formErrors.delivery_notes}
                        />
                        {formErrors.delivery_notes && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.delivery_notes}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">Goods Type</Form.Label>
                        <Form.Control
                          type="text"
                          name="goods_type"
                          onChange={handleChange}
                          value={data.goods_type}
                          isInvalid={formErrors.goods_type}
                        />
                        {formErrors.goods_type && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.goods_type}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">
                          Identification Position
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="identification_position"
                          onChange={handleChange}
                          value={data.identification_position}
                          isInvalid={formErrors.identification_position}
                        />
                        {formErrors.identification_position && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.identification_position}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="fw-600">Load Status</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="loading_status"
                          onChange={handleChange}
                          value={data.loading_status}
                          isInvalid={formErrors.loading_status}
                        >
                          <option value="pending1">Pending 1</option>
                          <option value="pending2">Pending 2</option>
                          <option value="loading">Loading</option>
                          <option value="closed">Closed</option>
                          <option value="complete">Complete</option>
                          <option value="transit">Transit</option>
                        </Form.Select>
                        {formErrors.loading_status && (
                          <Form.Control.Feedback type="invalid">
                            {formErrors.loading_status}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Form.Group>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={12} sm={12} xs={12} md={12}>
            <Card className="mb-3 border-0 shadow-sm rounded-2 p-0 m-0 ">
              <Card.Body className="text-start">
                <Button
                  variant="primary"
                  type="submit"
                  className="rounded-5 shadow-sm w-25"
                >
                  <FontAwesomeIcon icon={faCircleCheck} /> Update Load
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default LoadUpdate;
